/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { getColor } from '../../core/themev3';

const StyledBadge = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  font-weight: 500;
  min-width: 16px;
  height: 16px;
  width: auto;
  background: ${getColor('primary')};
  color: #fff;
  border-radius: 12px;
  text-align: center;
  float: right;
  padding: 0 6px;
`;

const Badge = props => {
  const { value } = props;
  return <StyledBadge {...props}>{value}</StyledBadge>;
};

export default Badge;
